"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHATBOT_IDENTITY_ID = exports.SYSTEM_IDENTITY_ID = void 0;
exports.SYSTEM_IDENTITY_ID = '00000000-0000-0000-0000-000000000000';
exports.CHATBOT_IDENTITY_ID = '8e88002b-3469-5e2f-8bc0-ba4cbabdeb69';
